import React, { ReactNode, useEffect } from "react";
import { Provider } from "react-redux";
import { createSamOrgQueryForApp } from "userful-chronos-app-common-js/dist/models/sam/SAMUtils";
import "./msgs/ClientMsgReceiver";
import { setAppIDForSamReceiver } from "./msgs/ClientMsgReceiver";
import {
    requestListPlayListDefs,
    requestListSourceAssets,
    requestListSourceDefs,
    requestListSourceSpecs,
    requestQueryPlaylistDefsAssets,
    requestQuerySourceDefs,
} from "./msgs/MsgSender";
import sourceAssetStore, { SourceAssetContext } from "./sourceAssetStore";
import { APP_IDS } from "userful-chronos-app-common-js/dist/models/common";

interface IProps {
    appID?: string;
    children: ReactNode;
}

const APPIDS_FOR_APPS = [
    APP_IDS.Artistic,
    APP_IDS.Decisions,
    APP_IDS.Engage,
    APP_IDS.Remote,
    APP_IDS.Spaces,
    APP_IDS.Trends,
    APP_IDS.Switch,
];

function SourceAssetsProvider(props: IProps) {
    useEffect(() => {
        requestListSourceSpecs();
        requestListSourceAssets();
        if (props.appID && APPIDS_FOR_APPS.includes(props.appID)) {
            setAppIDForSamReceiver(props.appID);
            const samOrgQuery = createSamOrgQueryForApp(props.appID);
            requestQuerySourceDefs(samOrgQuery);
            requestQueryPlaylistDefsAssets(samOrgQuery);
        } else {
            requestListSourceDefs();
            requestListPlayListDefs();
        }
    }, []);

    return (
        <Provider store={sourceAssetStore} context={SourceAssetContext}>
            {props.children}
        </Provider>
    );
}

export default SourceAssetsProvider;
